import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, App } from 'ionic-angular';

import { ImcpaAppProvider } from '../../providers/imcpaApp/imcpaApp';
import { MysqlService } from '../../services/mysql.service';

import { LoginPage } from '../login/login';
import { FarmListPage } from '../farms/farmList/farmList';
import { CampaignListPage } from '../campaigns/campaignList/campaignList';
import { ResourcesListPage } from '../resources/resourceList/resourcesList';
import { CertificatePage } from '../certificate/certificate/certificate';
import { TabsPage } from '../tabs/tabs';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  // styleUrls: [ 'home.scss', '../../theme/variables.scss' ]
})
export class HomePage {

  public goshala: any;
  public stat: any = {};

  constructor(private dbService: MysqlService, public myApp: ImcpaAppProvider, public cf: ChangeDetectorRef, public navCtrl: NavController, public app: App) {
    // this.cf.detectChanges();
    console.log(this.myApp.isLoggedIn)
    this.getStats()
  }

  ionViewDidEnter(){
    this.cf.detectChanges();
  }

  goToLoginPage(){
    if(this.myApp.isLoggedIn){
      this.myApp.access = {};
      this.myApp.isLoggedIn = false;
      this.navCtrl.push(TabsPage)
      // this.app.getRootNavs()[0].setRoot(LoginPage)
    } else {
      this.navCtrl.push(LoginPage);
    }
    
  }

  getStats(){
    // this.presentLoading()
    this.dbService.fetchDataV2('SELECT * FROM dashboardFarms')
      .map(res => res.json())
      .subscribe(res => {
          // this.loading.dismiss();
        this.stat=res.data[0];
        // this.getContinents();
        // console.log(this.goshalas);
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        // this.myreturnvalue = "Error : " + error;
        // console.log(this.myreturnvalue)
        // this.loading.dismiss();
      });
  }

  goToFarmListPage(){
  if(this.myApp.isLoggedIn){
    this.navCtrl.setRoot(FarmListPage)
  } else {
    this.navCtrl.push(FarmListPage)
  }
  }

  goToTemplesListPage() {
    this.navCtrl.push(CampaignListPage)
  }
  
  goToResourcesListPage() {
    this.navCtrl.push(ResourcesListPage)
  }

  goToCertificatePage() {
    if(this.myApp.isLoggedIn){
      this.navCtrl.setRoot(CertificatePage)
    } else {
      this.navCtrl.push(CertificatePage)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts